import { defaultListSettings } from "@saleor/config";
import useListSettings from "@saleor/hooks/useListSettings";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import { ListViews } from "@saleor/types";
import { useEffect, useState } from "react";

const usePagination = formik => {
  const [componentKey, setComponentKey] = useState<number>(0);

  const { updateListSettings, settings } = useListSettings(
    ListViews.CREATE_ORDER_DOMESTIC_LIST
  );
  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev
  } = usePaginationLocal(formik?.values?.lines, settings.rowNumber);
  useEffect(() => {
    toFirst();
  }, [settings?.rowNumber]);
  const pageInfo = {
    hasNextPage: !disableNext(),
    hasPreviousPage: !disablePrev()
  };
  const handleNextPage = () => {
    next();
    setComponentKey(componentKey + 1);
  };

  const handlePreviousPage = () => {
    prev();
    setComponentKey(componentKey + 1);
  };
  const lastPaginationState = () => {
    toLast();
    setComponentKey(componentKey + 1);
  };
  const handleNextLastPage = () => {
    lastPaginationState();
  };
  const handlePreviousFirstPage = () => {
    toFirst();
    setComponentKey(componentKey + 1);
  };

  const disabled = false; // if load disable is true,

  const totalCount = formik?.values?.lines?.length;
  useEffect(() => {
    updateListSettings(
      "rowNumber",
      defaultListSettings.CREATE_ORDER_DOMESTIC_LIST.rowNumber
    );
  }, []);

  return {
    currentData,
    pageInfo,
    handleNextPage,
    handlePreviousPage,
    handleNextLastPage,
    handlePreviousFirstPage,
    totalCount,
    disabled,
    settings,
    updateListSettings,
    toFirst
  };
};

export default usePagination;
